/**************************************************
 * Nombre:       Tarjeta_Testimonio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import comillas from '../../Recursos/ic_comillas.svg'
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useNavigate} from "react-router";


const Tarjeta_Testimonio = ({item}) => {
    const {sCell, masSM} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{

                py: 3,
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', mt: 1}}>
                <img src={comillas} width={40} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', mt: 3, px: 3}}>
                <Typography sx={{
                    fontSize: 20,
                    fontWeight: 400,
                    color: '#000000',
                    textAlign: 'center'
                }}>
                    {item.testimonio}
                </Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3, pb: 6}}>
                <Typography sx={{fontSize: 18, fontWeight: 600}}> {item.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Testimonio